export default "__VITE_ASSET__f1a55638__"